import { render, staticRenderFns } from "./SendMailTemplates.vue?vue&type=template&id=2e4628a8&scoped=true&"
import script from "./SendMailTemplates.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SendMailTemplates.vue?vue&type=style&index=0&id=2e4628a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4628a8",
  null
  
)

export default component.exports